import React from "react";
import SearchableDropdown from "../SearchableDropdown/SearchableDropdown";

function CountryFilter({
  value,
  handleChange,
  placeholder = "Select Country",
  disabled = false,
}) {
  const countries = JSON.parse(localStorage.getItem("countries")) ?? [];

  if (!countries || countries.length === 0) {
    return null;
  }

  return (
    <SearchableDropdown
      name="country_id"
      className={`filterBox ${disabled ? "disabled" : ""}`}
      setChangeValue={handleChange}
      placeholder={placeholder}
      disabled={disabled}
      val={value}
      dropdownData={countries}
    />
  );
}

export default CountryFilter;
